/* eslint-disable no-console */
import { hasDeviceEventData } from './device-event.helper';
import env from '../../source/helpers/env';

/**
 * Checks if we're running in a production environment.
 * Uses environment variable to determine the environment.
 */
const isProdEnv = () => {
    return /\b(?:prod|production)\b/gi.test(env.ENVIRONMENT);
};

/**
 * Logs main information about a device event with specified color.
 * Only logs fields that have values to keep console output clean.
 *
 * @param {Object} event - The device event object
 * @param {string} color - The color to use for console output
 */
const logMainInfo = (event, color) => {
    if (hasDeviceEventData(event)) {
        const finalColor = `color:${color}`;
        const goldenColor = 'color:goldenrod;font-weight:bold';

        console.log(`%cID:            ${event.data.assetViewerItem.assetId}`, finalColor);

        if (event.data.assetViewerItem.displayName) {
            console.log(`%cName:          %c${event.data.assetViewerItem.displayName}`, finalColor, goldenColor);
        }

        if (event.deviceEvent.metadata && event.deviceEvent.metadata.assetId) {
            console.log(`%cChild Asset:   ${event.deviceEvent.metadata.assetId}`, finalColor);
        }

        if (event.data.assetViewerItem.type) {
            console.log(`%cType:          ${event.data.assetViewerItem.type}`, finalColor);
        }

        console.log(`%cDeviceEventId: ${event.deviceEvent.id}`, finalColor);
        console.log(`%cAction:        ${event.deviceEvent.action}`, finalColor);
        console.log(`%cPage:          ${event.deviceEvent.page}`, finalColor);
    }
};

/**
 * Logs the start of a device event (green).
 * Displays event information in a grouped console output.
 *
 * @param {Object} event - The device event object
 */
export const logStart = (event) => {
    if (!isProdEnv()) {
        console.group();
        console.log('%c🏁 startDeviceEvent', 'font-weight:800;color:#13ff11');
        logMainInfo(event, '#13ff11');
        console.groupEnd();
    }
};

/**
 * Logs an update to a device event (blue).
 * Displays event information in a grouped console output.
 *
 * @param {Object} event - The device event object
 */
export const logUpdate = (event) => {
    if (!isProdEnv()) {
        console.group();
        console.log('%c🔄 updateDeviceEvent', 'font-weight:800;color:skyblue');
        logMainInfo(event, 'skyblue');
        console.groupEnd();
    }
};

/**
 * Logs the end of a device event (red).
 * Displays event information in a grouped console output.
 *
 * @param {Object} event - The device event object
 */
export const logStop = (event) => {
    if (!isProdEnv()) {
        console.group();
        console.log('%c🛑 stopDeviceEvent', 'font-weight:800;color:#ff2929');
        logMainInfo(event, '#ff2929');
        console.groupEnd();
    }
};

/**
 * Logs a warning about device event logging status.
 * Shows whether logging is enabled or disabled based on environment.
 */
export const warnDeviceEventLogging = () => {
    if (!isProdEnv()) {
        console.info('ℹ️ 🟢 Device event logging is %cenabled%c.', 'font-weight:800;color:#15ff00', 'font-weight:100;color:inherit');
    } else {
        console.info('ℹ️ 🔴 Device event logging is %cdisabled%c.', 'font-weight:800;color:red', 'font-weight:100;color:inherit');
    }
};
